export default __webpack_public_path__ + "static/Boston-9c595f8e94dbe690237ee8ba5bd5dab8.webp";